import { profitLossReportList } from '_services/reportService/reportService'
import { CommonDateRange, Heading } from 'components'
import React, { useEffect, useState } from 'react'
import moment from "moment";
import StorageService from 'utils/StorageServices';
import Loading from 'pages/Loading';
import { BsDownload } from 'react-icons/bs';
import { FiRefreshCcw } from 'react-icons/fi';

const ProfitLossReport = () => {

  const [profitLossData, setProfitLossData] = useState([])
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const [selectedRange, setSelectedRange] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
    // startDate: moment(firstDay).subtract(31, 'days'),
    // endDate: moment(lastDay),
  });


  const [filter, setFilter] = useState({
    limit: 100,
    offset: 1,
  });

  useEffect(() => {
    getProfitLossReportList()
  }, [filter])

  const getProfitLossReportList = async () => {
    setLoading(true)
    const payload = {
      ...filter,
      company_id: StorageService.getCompanyId(),
      start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
      end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
    }
    try {
      const res = await profitLossReportList(payload);
      if (res?.responseCode == 200) {
        setProfitLossData(res?.data)
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      offset: 1,
    }));
  };

  const resetFunction = () => {
    const newStartDate = moment().startOf('month');
    const newEndDate = moment().endOf('month');

    setSelectedRange({
      startDate: newStartDate,
      endDate: newEndDate,
    });
    // const newStartDate = moment(firstDay).subtract(31, 'days');
    // const newEndDate = moment(lastDay);

    // setSelectedRange({
    //   startDate: newStartDate,
    //   endDate: newEndDate,
    // });

    setFilter((s) => ({
      ...s,
      offset: 1,
    }));
  };

  return (
    <>
      <div className='__znDe_mainBx'>
        <div>
          <div className='panel-heading'>
            <h2><span>Profit and Loss Report</span></h2>

            <div className='panel-ctrls report-control'>
              <div>
                <CommonDateRange
                  key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                  initialStartDate={selectedRange.startDate}
                  initialEndDate={selectedRange.endDate}
                  onApply={handleApply}
                />
              </div>

              <button className='__bxs_srBtn'>
                <BsDownload />
              </button>

              <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                <FiRefreshCcw />
              </button>
            </div>

          </div>
        </div>

        <div className='_mrktLoad_mainBx __main_p_n_l'>

          {loading ? <div className='d-flex h-100 justify-content-center align-items-center' style={{ position: 'relative', width: '100%' }}><Loading /></div> :

            <div className='_pNl_listBx'>
              <div className='_pNl_list_otrBx'>

                <div className='clear-both text-center p-10'>
                  <div class="__hrlMx_head" >
                    {/* <p>{profitLossData?.company?.company ? profitLossData?.company?.company : '-'}</p> */}
                    <p>Hexaware</p>
                    <h4>Profit and Loss Report</h4>
                    <h5>From <span> {moment(selectedRange.startDate).format("DD-MMM-YYYY")}</span> To <span> {moment(selectedRange.endDate).format("DD-MMM-YYYY")}</span> </h5>
                  </div>
                </div>


                <div className='_pNl_list_inrBx'>
                  <div className='__pNlFlx' >
                    <span>Own/ Leased Vehicle Trips</span> <span>{profitLossData?.own_leased_revenue?.total_trips}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Revenue</span> <span>₹ {profitLossData?.own_leased_revenue?.total_party_freight}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Trip Charges</span> <span>₹ {profitLossData?.own_leased_revenue?.total_truck_freight}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Claims</span> <span>₹ {profitLossData?.own_leased_revenue?.claims}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Other Charges</span> <span>₹ {profitLossData?.own_leased_revenue?.other_charges}</span>
                  </div>

                  <div className='__pNlFlx __plTotalBl' >
                    <span>Trip Profit</span> <span>₹ {profitLossData?.own_leased_revenue?.total_profit_loss}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Servicing</span> <span>₹ {profitLossData?.own_leased_revenue?.servicing}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Documents</span> <span>₹ {profitLossData?.own_leased_revenue?.documents}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Salary</span> <span>₹ {profitLossData?.own_leased_revenue?.salary}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Fastag (Not Associated)</span> <span>₹ {profitLossData?.own_leased_revenue?.fastag}</span>
                  </div>

                  <div className='__pNlFlx __plTotalBl' >
                    <span>Profit from Own/ Leased (A)</span> <span>₹ {profitLossData?.own_leased_revenue?.profit_A}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Market Vehicle Trips</span> <span>{profitLossData?.market_revenue?.total_trips}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Revenue</span> <span>₹ {profitLossData?.market_revenue?.total_party_freight}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Trip Charges</span> <span>₹ {profitLossData?.market_revenue?.total_truck_freight}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Claims</span> <span>₹ {profitLossData?.market_revenue?.claims}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Other Charges</span> <span>₹ {profitLossData?.market_revenue?.other_charges}</span>
                  </div>

                  <div className='__pNlFlx __plTotalBl' >
                    <span>Trip Profit Market (B)</span> <span>₹ {profitLossData?.market_revenue?.profit_B}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Expenses</span> <span></span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>General Expenses</span> <span>₹ {profitLossData?.expenses?.office_expenses}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Salary</span> <span>₹ {profitLossData?.expenses?.salary}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Claims</span> <span>₹ {profitLossData?.expenses?.claims}</span>
                  </div>

                  <div className='__pNlFlx' >
                    <span>Other Charges</span> <span>₹ {profitLossData?.expenses?.other_charges}</span>
                  </div>

                  <div className='__pNlFlx __plTotalBl' >
                    <span>Total Expenses (C)</span> <span>₹ {profitLossData?.expenses?.total_expenses}</span>
                  </div>

                  <div className='__pNlFlx __plTotalYl' >
                    <span>Profit & Loss (A+B-C)</span> <span>₹ {profitLossData?.profit_and_loss}</span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default ProfitLossReport